<template>
  <v-container fluid>
    <v-row>
      <v-col v-if="addingAddress" cols="12">
        <v-row>
          <v-col cols="12" md="6">
            <trans-select
              :label="$t('components.canada_post_address.country')"
              :item="selected"
              propertyName="Country"
              :items="options.Models.Country"
              :rules="[$rules.required]"
              class="required"
              clearable
            ></trans-select>
          </v-col>
          <template v-if="selected.Country">
            <v-col cols="12" md="6" v-if="selected.Country.IsOther">
              <no-autocomplete-textfield
                :label="$t('headers.members_management.OtherCountry')"
                v-model="otherCountry"
                class="required"
                :rules="[$rules.required]"
              ></no-autocomplete-textfield>
            </v-col>
            <v-col
              cols="12"
              md="6"
              v-if="
                (selected.Country.IsOther && otherCountry !== null) ||
                  !selected.Country.IsOther
              "
            >
              <v-autocomplete
                :label="
                  $t('components.canada_post_address.start_typing_your_address')
                "
                v-model="selectedAddress"
                :items="searchResults"
                return-object
                :loading="isAddressSearchLoading"
                :search-input.sync="searchValue"
                item-text="Description"
                item-value="Id"
                clearable
                append-outer-icon="mdi-magnify"
                :rules="[$rules.required]"
                class="required"
                ref="addressList"
              ></v-autocomplete>
            </v-col>
          </template>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" v-else>
        <!-- <span style="white-space: pre"> -->
        {{ fetchedAddress }}
        <!-- </span> -->
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6" align-self="center">
        <v-btn
          v-show="!addingAddress"
          color="primary"
          @click="
            fetchedAddress = undefined;
            selected.Country = undefined;
            selectedAddress = undefined;
            addingAddress = true;
          "
          :disabled="readOnly"
        >
          <span>
            {{
              fetchedAddress === undefined
                ? $t("globals.add")
                : $t("globals.edit")
            }}
          </span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { tokens } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
import TransSelect from "@/components/TransSelect";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
export default {
  props: ["address", "readOnly"],
  components: { TransSelect, NoAutocompleteTextfield },
  data() {
    return {
      isAddressSearchLoading: false,
      isAddressRetrieveLoading: false,
      fetchedAddress: undefined,
      canadaPostAddress: undefined,
      addingAddress: false,
      addedAddress: false,
      selectedAddress: undefined,
      searchResults: [],
      selected: {
        Country: null,
      },
      searchValue: undefined,
      otherCountry: null,
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("common", ["language", "settings"]),
  },
  watch: {
    "selected.Country": {
      handler(v) {
        console.log(v);
      },
      immediate: true,
    },
    searchValue: {
      async handler(v) {
        console.log(v, this.otherCountry);
        if (v === null) {
          return;
        }

        if (this.isAddressSearchLoading) {
          return;
        }
        this.isAddressSearchLoading = true;
        try {
          this.searchResults = (await this.canadaPostFind({
            payload: {
              Key: this.settings.CanadaPostKey,
              SearchTerm: this.searchValue,
              Country: this.selected.Country.IsOther
                ? this.otherCountry
                : this.selected.Country.Name,
              LanguagePreference: this.language.language.toUpperCase(),
            },
          })).data.Items.map((o) => {
            o.Description = `${o.Text} ${o.Description}`;
            return o;
          });
          console.log(this.searchResults);
        } catch (error) {
          console.log(error);
        } finally {
          this.isAddressSearchLoading = false;
        }
      },
    },
    selectedAddress: {
      async handler(v) {
        console.log(v);
        if (v === null) {
          return;
        }
        if (this.isAddressRetrieveLoading) {
          return;
        }
        console.log(v, this.selectedAddress, this.otherCountry);
        if (this.selectedAddress.Next === "Find") {
          this.isAddressSearchLoading = true;
          try {
            let payload = {
              Key: this.settings.CanadaPostKey,
              SearchTerm: `${this.selectedAddress.Description}`,
              Country: this.selected.Country.IsOther
                ? this.otherCountry
                : this.selected.Country.Name,
              LanguagePreference: this.language.language.toUpperCase(),
            };
            if (this.selectedAddress.Id) {
              payload.LastId = this.selectedAddress.Id;
            }
            this.searchResults = (await this.canadaPostFind({
              payload: payload,
            })).data.Items.map((o) => {
              o.Description = `${o.Text} ${o.Description}`;
              return o;
            });
            console.log(this.searchResults);
            this.searchValue = null;
            this.onFocus();
          } catch (error) {
            console.log(error);
          } finally {
            this.isAddressSearchLoading = false;
          }
        } else if (this.selectedAddress.Next === "Retrieve") {
          this.isAddressRetrieveLoading = true;
          try {
            this.canadaPostAddress = (await this.canadaPostRetrieve({
              payload: {
                Key: this.settings.CanadaPostKey,
                Id: this.selectedAddress.Id,
                LanguagePreference: this.language.language.toUpperCase(),
              },
            })).data.Items;
            console.log(this.canadaPostAddress);
            if (this.selected.Country.IsOther) {
              if (Array.isArray(this.canadaPostAddress)) {
                this.fetchedAddress = this.canadaPostAddress[0].Label;
              } else {
                this.fetchedAddress = this.canadaPostAddress.Label;
              }
            } else {
              this.fetchedAddress = this.canadaPostAddress.filter((o) =>
                this.language.language.toUpperCase() === "EN"
                  ? o.Language === "ENG"
                  : o.Language === "FRE"
              )[0].Label;
            }
            console.log(this.fetchedAddress, this.canadaPostAddress);
            this.addingAddress = false;
            this.addedAddress = true;
            this.$emit("update-address", this.fetchedAddress);
          } catch (error) {
            console.log(error);
          } finally {
            this.isAddressRetrieveLoading = false;
          }
        }
      },
    },
  },
  mounted() {
    if (this.address) {
      this.fetchedAddress = this.address;
    }
  },
  methods: {
    ...mapActions("data", ["canadaPostFind", "canadaPostRetrieve"]),
    onFocus() {
      this.$refs.addressList.isMenuActive = true;
    },
    unmask(v, mask) {
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
  },
};
</script>

<style></style>
